import { useState } from "react";
import { ECCOIcon } from "@ecco/ui/ecco-icon";
import { InputGroup } from "@ecco/ui/input-group";
import { InputRightElement } from "@ecco/ui/input-element";
import { Input } from "@ecco/ui/input";
import { IconButton } from "@ecco/ui/icon-button";
import { Button } from "@ecco/ui/button";
import { Field } from "@ecco/ui/field";
import { getPrivacyAttributes } from "@lib/monitoring/privacyAttributes";

const PasswordField = ({
    id = "password",
    ariaLabelledBy,
}: {
    id: string;
    ariaLabelledBy: string;
}) => {
    const [isHidden, setIsHidden] = useState(true);
    const inputType = isHidden ? "password" : "text";
    //TODO: intl - aria label problems
    return (
        <InputGroup {...getPrivacyAttributes()}>
            <Field
                as={Input}
                id={id}
                name={id}
                aria-labelledby={ariaLabelledBy}
                type={inputType}
                autoComplete="new-password"
                sx={{
                    "::-ms-reveal": {
                        display: "none",
                    },
                }}
            />
            <InputRightElement>
                <IconButton
                    as={Button}
                    aria-label={isHidden ? "Hide password" : "Show password"}
                    bg={"transparent !important"}
                    color={"black"}
                    variant={"tertiary"}
                    icon={<ECCOIcon name={isHidden ? "passwordhide" : "passwordshow"} />}
                    size={"sm"}
                    display={"flex"}
                    _hover={{ color: "black", bg: "transparent" }}
                    onClick={() => setIsHidden(!isHidden)}
                />
            </InputRightElement>
        </InputGroup>
    );
};

export default PasswordField;
